<template>
  <v-card>
    <v-toolbar flat>
      <v-icon>person</v-icon>
      <v-toolbar-title>{{ $t('auth.logout') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <h2>{{ $t('auth.loggingOut') }}</h2>
    </v-card-text>
  </v-card>
</template>

<script>
import UserActionResultSender from "@/components/application/UserActionResultSender";

export default {
  mounted() {
    UserActionResultSender.showSuccessFeedback('auth.error.signedOut');
    this.$store.dispatch("userSignOut");
    this.routeToLogin();
  },
  methods: {
    routeToLogin() {
      this.$router.push("/");
      // this.$router.replace("application/signIn");
    },
  },
};
</script>

<style scoped>
#app .main-content {
  max-width: 800px;
}
.pincode-container {
  width: 350px;
}
</style>
